import { 
    gql, 
    useQuery 
} from "@apollo/client";
import { FindLocationByIdAdminQueryQuery, FindLocationByIdAdminQueryQueryVariables } from "../../../../../schemaTypes";

export const findLocationByIdAdminQuery = gql`
  query FindLocationByIdAdminQuery(
    $id: String!
  ) {
    findLocationByIdAdmin(
        id: $id
    ) {
     id
      district
      city
      streetName
      country
      postalCode
      landmark
      createdAt
    	updatedAt
      latitude
      longitude
      isArchive
    	createdBy{
        id
        admin{
          id
          level
          firstname
          lastname
        }
      }
      customersCount
    }
  }
`;

export interface WithFindLocationByIdAdmin {
  location: FindLocationByIdAdminQueryQuery["findLocationByIdAdmin"] | null;
  loading: boolean;
}

interface Props {
  locationId: string;
  children: (data: WithFindLocationByIdAdmin) => React.ReactElement | null;
}

export const FindLocationByIdAdminController: React.FC<Props> = ({ locationId, children }) => {
  const { data, loading } = useQuery<
    FindLocationByIdAdminQueryQuery,
    FindLocationByIdAdminQueryQueryVariables
  >(findLocationByIdAdminQuery, {
    variables: { id: locationId },
  });

  let location: FindLocationByIdAdminQueryQuery["findLocationByIdAdmin"] | null = null;
  if (data && data.findLocationByIdAdmin) {
    location = data.findLocationByIdAdmin;
  }

  return children({
    location,
    loading,
  });
};